// extracted by mini-css-extract-plugin
export default {"CollapseNoPadding":"hsxaSjQx","TitleText":"ilA95iKB","Number":"GF7DoGE8","TitleRow":"NlmxHp2M","ClaimRow":"vWmlJhdI","RowText":"iDa455wt"};